<template>
  <li :class="classes" @click.stop="select" @mousedown.prevent>
    <slot></slot>
  </li>
</template>

<script>
const prefixCls = "k-select-item";

export default {
  name: "k-select-item",

  props: {
    value: { type: [String, Number], required: true },
    disabled: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Boolean,
      default: false
    },
    isFocused: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      return [
        `${prefixCls}`,
        {
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-selected`]: this.selected,
          [`${prefixCls}-focus`]: this.isFocused
        }
      ];
    },
    optionLabel() {
      return (this.$el && this.$el.textContent) || "-";
    }
  },
  data() {
    return {
      prefixCls: prefixCls
    };
  },
  methods: {
    select() {
      if (this.disabled) {
        return false;
      }

      this.dispatch("k-select", "on-select-selected", {
        value: this.value,
        label: this.optionLabel
      });

      this.$emit("on-select-selected", {
        value: this.value,
        label: this.optionLabel
      });
    },
    dispatch(componentName, eventName, params) {
      let parent = this.$parent || this.$root;
      let name = parent.$options.name;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    }
  }
};
</script>
